/**
 * Fields of Order projected into service records.
 */
export const SERVICE_ORDER_FIELDS: string = `
  orderId
  orderNumber
  orderStatus
  reservationNumber
  reservationStatus
  orderObservation
  scheduledPaymentDate
  paidAt
  pdfStatus
  pdfGeneratedAt
  lastPdfError
`;
